import { Link } from 'react-router-dom';

const styles = {
  primary: 'border-ink bg-primary text-ink shadow-hard hover:bg-[#ff7d7d] dark:border-ink dark:text-ink',
  secondary: 'border-ink bg-white text-ink shadow-hard hover:bg-yellow dark:border-canvas dark:bg-canvas dark:text-ink dark:shadow-[4px_4px_0_#FDF2E9]',
  ghost: 'border-transparent bg-transparent text-ink shadow-none hover:border-ink hover:bg-white dark:text-canvas dark:hover:border-canvas dark:hover:bg-white/10',
};

export default function Button({ to, href, children, variant = 'primary', className = '', ...props }) {
  const classes = `focus-ring inline-flex min-h-11 items-center justify-center gap-2 rounded-lg border-2 px-5 py-2.5 text-base font-semibold transition duration-150 active:translate-x-1 active:translate-y-1 active:shadow-none disabled:cursor-not-allowed disabled:opacity-50 ${styles[variant]} ${className}`;
  if (to) {
    return <Link to={to} className={classes} {...props}>{children}</Link>;
  }
  if (href) {
    return <a href={href} className={classes} {...props}>{children}</a>;
  }
  return <button className={classes} {...props}>{children}</button>;
}
